import React from 'react';
import PropTypes from 'prop-types';
import { GridItem, Text, Flex, Container, Button } from '@chakra-ui/react';
import { generateSectionId } from '@rsc/ui-components/dept/utils/generateSectionId';
import MediaBackground from '@rsc/ui-components/dept/molecules/MediaBackground';
import Link from '@rsc/ui-components/tailwind/Link';

function FeaturedContentWideMedia({ block }) {
  const { headline, copy, cta, alignment, featuredContentWideMedia } = block;

  const handleAlignment = (
    leftValue,
    centerValue,
    rightValue,
    defaultAlignment
  ) => {
    const values = {
      left: leftValue,
      center: centerValue,
      right: rightValue,
    };

    return {
      base: defaultAlignment ?? leftValue,
      lg: values[alignment] || defaultAlignment,
    };
  };

  return (
    <Container {...generateSectionId(block)} py={[14, null, 10]}>
      <MediaBackground
        background={featuredContentWideMedia}
        h={['20.43rem', null, '35.5rem']}
        borderRadius="24px"
      >
        <GridItem
          as={Flex}
          colSpan={handleAlignment(5, 6, 5)}
          gridColumnStart={handleAlignment(1, 4, 8)}
          alignItems={handleAlignment('flex-start', 'center', 'flex-end')}
          textAlign={handleAlignment('left', 'center', 'right')}
          direction="column"
          justify="end"
          p={[6, null, 16]}
        >
          {headline && (
            <Text
              as="h2"
              textStyle="h2"
              color="typography.lighter"
              mb={[0, null, 2]}
              fontWeight="black"
              zIndex={1}
            >
              {headline}
            </Text>
          )}

          {copy && (
            <Text
              display={['none', null, 'block']}
              textStyle="bodyLarge"
              color="typography.lighter"
              fontWeight="bold"
              width="90%"
              zIndex={1}
            >
              {copy}
            </Text>
          )}
          {cta?.text && (
            <Button mt={[4, null, 6]} as={Link} link={cta.link}>
              {cta.text}
            </Button>
          )}
        </GridItem>
      </MediaBackground>
    </Container>
  );
}

FeaturedContentWideMedia.propTypes = {
  block: PropTypes.shape({
    headline: PropTypes.string,
    copy: PropTypes.string,
    alignment: PropTypes.oneOf(['left', 'center', 'right']),
    cta: PropTypes.shape({
      text: PropTypes.string,
      link: PropTypes.shape({
        href: PropTypes.string,
        linkType: PropTypes.string,
        internalLink: PropTypes.shape({
          slug: PropTypes.shape({
            current: PropTypes.string,
          }),
        }),
      }),
      blank: PropTypes.bool,
    }).isRequired,
    featuredContentWideMedia: PropTypes.shape({
      image: PropTypes.shape({
        asset: PropTypes.shape({
          url: PropTypes.string,
        }),
        alt: PropTypes.string,
        hotspot: PropTypes.shape({
          x: PropTypes.number,
          y: PropTypes.number,
        }),
      }),
    }),
  }),
}.isRequired;

export default FeaturedContentWideMedia;
